import {GetSeferData}   from "SeferPetach/GetData";

export async function getData(data) {
    var payload = await GetSeferData("oldreport", data);
    return (payload);
}
